import '@/js/desktop/plugins/fotorama/fotorama';

import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import HotelPageSeoModel from '@/js/desktop/components/hotel/model/HotelPageSeoModel';
import Vue from 'vue';

import getStore from '@ve/services/getStore/getStore';
import HotelMinPriceButtonSeoDesktop from '@ve/components/hotel/hotelMinPriceButton/desktop/HotelMinPriceButtonSeo.vue';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';
import initHotelPageGallery from '../hotel/index/initHotelPageGallery';
import HotelPageView from '../hotel/index/HotelPageDistributed';
import HotelPageReviewsView from '../hotel/index/reviews/HotelPageReviews';

import '@/css/desktop/tooltip.scss';
import '../hotel/index/hotelCssImport';
import './styles/index.scss';

@extendDecorator({
    events: {
        'click .page-tabs .page-tabs__item': 'goToSectionsHandler',
        'click .gallery-container .gallery-categories .gallery-categories__item': 'onCategoryHandler',
    },
    bindings: {
        '.page-tabs .page-tabs__item': "classes:{ 'no-click': isDisabled }",
        '.resort-map-view .viewMapLink': "classes:{ 'no-click': isDisabled }",
    },
})
class HotelSeo extends HotelPageView {
    initHotelDescriptionStore() {}

    transferDataFromWindowToVuex() {}

    initHotelDescription() {}

    initHotelMinPriceButton() {
        const store = getStore();
        const { hotelInfo } = window.appConfig;

        new Vue({
            name: 'HotelMinPriceButton',
            render: (h) => h(HotelMinPriceButtonSeoDesktop, {
                nativeOn: {
                    click: () => {
                        this.subview.tourSearch.formSubmit();
                        this.gotoSearchResults();
                        this.hotelTrackingService.headPriceButtonClick();
                    },
                },
                props: {
                    pageMinPrice: window.appConfig.hotelInfo.minPrice,
                    hotelNameWithCategory: `${hotelInfo.name} ${hotelInfo.categoryText}`,
                },
            }),
            store,
        }).$mount('#hotelMinPriceButtonContainer');
    }

    onCategoryHandler(e) {
        const $target = $(e.currentTarget);
        const categoryName = $target.data('name');
        const fotoramaDivs = this.model.get('fotoramaDivs');

        if (fotoramaDivs[categoryName]) {
            const fotorama = fotoramaDivs[categoryName];
            fotorama.requestFullScreen();
            return;
        }

        const $slides = $target.find('.sp-slide');
        const $images = $slides.children();

        if (!$images && !$images.length) return;

        $images.each(function () {
            const $image = $(this);
            const src = $image.data('src');
            $image.attr('src', src);
        });
        this.$fotoramaDiv = $slides.fotorama({
            enableifsingleframe: true,
            nav: 'thumbs',
            allowfullscreen: 'native',
            thumbborderwidth: 0,
            thumbmargin: 0,
            thumbheight: 120,
            thumbwidth: 164,
            click: true,
            keyboard: true,
            swipe: true,
        });
        const fotorama = this.$fotoramaDiv.data('fotorama');
        fotorama.requestFullScreen();
        fotoramaDivs[categoryName] = fotorama;
        this.model.set('fotoramaDivs', fotoramaDivs);
    }

    goToSectionsHandler(e) {
        const { id } = e.currentTarget;

        if (!id) return;

        const sectionId = id.split('page-tabs-')[1];

        if (!sectionId) return;

        $('html,body').animate({
            scrollTop: $(`.${sectionId}`).offset().top - 160,
        }, 500);
    }

    gotoMap() {
        $('html, body').animate({ scrollTop: $('.hotelsMap').offset().top - 180 }, 500);
        if (!$('#showMapContainer:visible').length) {
            $('#openMap').click();
        }
    }

    initGallery() {
        initHotelPageGallery({
            el: '.gallery-wrapper__images',
            images: window.appConfig?.hotelPhotos || null,
            videos: window.appConfig?.hotelVideos || null,
            isVisibleThumbs: false,
        });
    }

    initModel() {
        this.model = new HotelPageSeoModel();
    }

    initialize(options) {
        this.dataLayerAnalytics = new DataLayerAnalytics({
            step: 'hotelPage',
            maxStep: 2,
        });
        this.hotelTrackingService = new HotelTrackingService();
        super.initialize({ ...options, ...{ dataLayerAnalytics: this.dataLayerAnalytics } });
        this.initGallery();
        const hotelPageReviews = new HotelPageReviewsView({
            el: '#reviewsTabs',
        });
        hotelPageReviews.ourReviewsList.load();

        this.subview.tourSearch.searchFormModel.get('touristGroup').on('change', () => {
            this.model.set('isDisabled', false);
        });
    }
}

export default HotelSeo;
